export const REACT_APP_BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
export const REACT_APP_BACKEND_STORAGE_URL =
  process.env.REACT_APP_BACKEND_STORAGE_URL;
  export const CHAT_SERVICE_API_URL = process.env.REACT_APP_CHAT_SERVICE_API_URL;
  export const CHAT_SERVICE_SOCKET_URL = process.env.REACT_APP_CHAT_SERVICE_SOCKET_URL;